/* src/app/views/template/components/templates/web/web-product-templates/web-product-template-list/web-product-template-list.component.scss */
/*# sourceMappingURL=web-product-template-list.component.css.map */
